import React, { useCallback, useContext, useEffect, useState } from "react";
import InputField from "../../Components/InputField/InputField";

import { useLocation, useNavigate } from "react-router-dom";
import { ManageApis } from "../../AppServices/ManageApi";
import DataTable from "../../Components/DataTable/DataTable";
import moment from "moment";
import { globalContext } from "../../App";
import { downloadDifferentType, formatTextString, splitDeviceBrand } from "../../Common/Utils/Utils";
import { downloadPdf } from "../../Common/Functions/PdfDownload/pdfDownload";
import { exportToExcel } from "../../Common/Functions/CsvDownload/csvDownload";
import Dropdown from "react-bootstrap/Dropdown";
import DownloadComponent from "../../Components/DownloadComponent/DownloadComponent";
import { getDownloadFormat } from "../../Common/Utils/intialValues";

const columnWidths = {
  agentId: { cellWidth: 50, color: "red" }, // cellWidth of the 'agentId' column (in points)
  agentName: { cellWidth: 100 }, // cellWidth of the 'agentName' column
  device_details: { cellWidth: 100 }, // cellWidth of the 'device_details' column
  location: { cellWidth: 200 }, // cellWidth of the 'location' column
  created_date: { cellWidth: 60 }, // cellWidth of the 'created_date' column
};

const dataColumn = [
  {
    title: "Agent Id",
    dataKey: "agentId",
  },
  {
    title: "Agent Name",
    dataKey: "agentName",
  },
  {
    title: "Device Details",
    dataKey: "device_details",
  },
  {
    title: "Location",
    dataKey: "location",
  },
  { 
    title: "Login Time",
    dataKey: "created_date",
  },
];

const dataColumnCsv = [
  { header: "Agent ID", key: "agentId", width: 15 },
  { header: "Agent Name", key: "agentName", width: 30 },
  { header: "Device Details", key: "device_details", width: 35 },
  { header: "Location", key: "location", width: 50 },
  { header: "Login Time", key: "created_date", width: 20 },
];

const downloadOptions = [
  {
    type: "pdf",
    label: "Download as PDF",
    icon: "far fa-file-pdf",
    iconColor: "danger",
  },
  {
    type: "csv",
    label: "Download as CSV",
    icon: "fas fa-file-csv",
    iconColor: "primary",
  },
  {
    type: "excel",
    label: "Download as Excel",
    icon: "fas fa-file-excel",
    iconColor: "success",
  },
];

function LoginReports({ route }) {
  const location = useLocation();
  const { state } = location || {};
  // const {agentId}=agentId
  // console.log(state);
  const [TableData, setTableData] = useState([]);

  const [pageSize, setpageSize] = useState(10);
  const [TotalCount, setTotalCount] = useState();
  const [currentPage, setcurrentPage] = useState(1);
  const [Date, setDate] = useState([]);

  const [errorMsg, seterrorMessage] = useState({});
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [totalLeadReportListData, setTotalLeadReportListData] = useState({});

  const { setIsLoader } = useContext(globalContext);
  const Navigate = useNavigate();
  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };
  const columns2 = [
    {
      title: "Sl No",
      dataIndex: "key",
    },
    {
      title: "Date",
      dataIndex: "created_date",
    },
    {
      title: "Device Details",
      dataIndex: "device_details",
      render: (text, record, index) => {
        return (
          <div>
            {record?.device_details &&
              Object.entries(record.device_details).map(([key, value]) => (
                <div key={key}>
                  <strong>{splitDeviceBrand(key)}:</strong> {value}
                </div>
              ))}
          </div>
        );
      },
    },
    {
      title: "Latitude",
      dataIndex: "lat",
    },
    {
      title: "Longitude",
      dataIndex: "long",
    },
    {
      title: "Login Time",
      dataIndex: "Time",
    },
    {
      title: "Location",
      dataIndex: "location",
    },
  ];
  useEffect(() => {
    fetchTableDatas();
  }, [currentPage, pageSize]);

  useEffect(() => {
    if (Date.length === 0) {
      setIsFilterApplied((prev) => true);
      fetchTableDatas();
    } else {
      setIsFilterApplied((prev) => false);
    }
  }, [Date]);

  const fetchTableDatas = async (filter) => {
    try {
      setIsLoader(true);
      const startDateValue = Date?.[0];
      const endDateValue = Date?.[1];
      const page = 1;
      const limit = 10;

      let params = startDateValue ? `startDate=${startDateValue}&` : "";
      params += endDateValue ? `endDate=${endDateValue}&` : "";
      let startingIndex;
      if (filter) {
        params += `agentId=${state?.agentId}&page=${page}&limit=${limit}`;
        startingIndex = (page - 1) * limit + 1;
      } else {
        params += `agentId=${state?.agentId}&page=${currentPage}&limit=${pageSize}`;
        startingIndex = (currentPage - 1) * pageSize + 1;
      }

      let path = global.ReportsLogs + `?${params}`;
      let reqstBody = {};
      const response = await commonApiCall({ path, reqstBody, method: "get" });

      if (response.message === "Success") {
        const { data } = response.response_data || {};
        setTableData(
          data.docs.map((itm, index) => ({
            ...itm,
            key: startingIndex + index,
            created_date: itm.created_date
              ? moment(itm.created_date).format("DD-MM-YYYY")
              : "",
            Time: itm.created_date
              ? moment(itm.created_date).format("hh:mm A")
              : "",
              lat:itm.latitude == 0 ? "N/A" :itm.latitude,
              long:itm.longitude == 0 ? "N/A" :itm.longitude,
              location:itm.location ? itm.location : "N/A"
          }))
        );
        setTotalCount(data.total);
        setcurrentPage(parseInt(data.page));
        setpageSize(parseInt(data.limit));
        setIsFilterApplied(Boolean(startDateValue || endDateValue));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  async function commonApiCall({
    path,
    reqstBody,
    method = "post",
    resp_type,
  }) {
    if (!path) return;
    try {
      const result = await ManageApis(method, path, reqstBody, "", resp_type);
      // console.log(result);
      return result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  const handleAction = () => {
    Navigate("/reports");
  };

  function onChangeTable(current, pageSize) {
    setcurrentPage(current);
    setpageSize(parseInt(pageSize));
  }

  const handleChange = (value, name) => {
    // debugger
    if (name === "Date") {
      setDate(value);
    }
  };

  const formatForPdfData = (data) => {
    try {
      if (data.length) {
        return data.map((row) => {
          const formattedRow = { ...row };

          // Format the created_date using moment.js
          if (formattedRow.created_date) {
            formattedRow.created_date = moment(
              formattedRow.created_date
            ).format("DD-MM-YYYY h:mmA");
          }

          // Format device_details with or without line breaks
          if (
            formattedRow.device_details &&
            typeof formattedRow.device_details === "object"
          ) {
            const separator = ", ";
            formattedRow.device_details = Object.entries(
              formattedRow.device_details
            )
              .map(([key, value]) => `${formatTextString(key)}: ${value}`)
              .join(separator);
          }

          return formattedRow;
        });
      } else {
        return data;
      }
    } catch (error) {
      console.error("Error formatting data:", error);
      return data;
    }
  };

  const getDownloadDetails = (type, data) =>{
    const heading = "Agent Login Report";
    const pdfName = "LoginReports";
    const rows = formatForPdfData(data, type !="pdf");
    const format = getDownloadFormat(type);
    let columns = {};

    if(type === "pdf"){
      columns = dataColumn
    } else {
      columns = dataColumnCsv
    }

   
    return { header: heading, rows: rows, columns, widths: columnWidths, name:`${pdfName}${format}`  }
  
  }

  async function downloadPDF(type) {
    setIsLoader(true);
    try {
      const startDateValue = Date?.[0];
      const endDateValue = Date?.[1];
      let params = startDateValue ? `startDate=${startDateValue}&` : "";
      params += endDateValue ? `endDate=${endDateValue}&` : "";
      const path = `${global.baseUrl}${global.downloads}?agentId=${state?.agentId}&${params}`;
      const reqstBody = {};
      const method = "get";

      const result = await commonApiCall({ path, reqstBody, method });
      if (result.message === "Success") {
        const data = getDownloadDetails(type, result?.response_data?.data);
        
        downloadDifferentType(type, data)
        
      } else {
        console.error("Error downloading PDF:", result.message);
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setIsLoader(false);
    }
  }

  const resetFilter = () => {
    setIsFilterApplied(false);
    setDate((prev) => []);
    seterrorMessage({});
  };

  return (
    <>
      <div className="mt-3">
        <div className="fw_600 font_18 text_master ms-2 mb-0">
          <div
            onClick={handleAction}
            className="round_sm d-flex me-2 justify-content-center align-items-center bg_gray6 rounded-circle cursor-pointer d-inline-flex px_hover_1"
          >
            <i class="fas fa-chevron-left"></i>
          </div>
          Reports
        </div>

        <div className="d-flex bg_gray11 p-3 mt-3">
          <div className="col-4">
            <div>
              <h2 className="font_13 font_400 text-black">DC Agent ID</h2>
              <h1 className="text_master font_500 font_14 mb-0">
                {state?.agentId}
              </h1>
            </div>
          </div>
          <div className="col-4">
            <div>
              <h2 className="font_13 font_400 text-black">DC Agent Name</h2>
              <h1 className="text_master font_500 font_14 mb-0">
                {state?.agentName}
              </h1>
            </div>
          </div>
          <div className="col-4">
            <div>
              <h2 className="font_13 font_400 text-black">Branch</h2>
              <h1 className="text_master font_500 font_14 mb-0">
                {state?.branchName}
              </h1>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end px-2">
          <div className="d-flex flex-column pt-2 justify-content-end">
            <h2 className="text-black  mb-2 font_13 font_400"></h2>
            <div className="d-flex gap-2 justify-content-end">
              <div className="arco_custom_date">
                <InputField
                  required
                  type={"date-range"}
                  disabledDate={disabledDate}
                  name={"Date"}
                  onchange={(name, value) => handleChange(name, value)}
                  value={Date}
                  onClear={() => resetFilter()}
                  // options={[1, 5, 8, 8]}
                />
              </div>
              <div className="">
                <button
                  className="btn btn-master  font_15 font_500 text-nowrap"
                  onClick={() => fetchTableDatas(true)}
                  disabled={isFilterApplied}
                >
                  Apply Filter
                </button>
              </div>
              <div className="d-none">
                <div
                  onClick={() => downloadPDF()}
                  className="border bd_master w_40x h_36x d-flex align-items-center justify-content-center cursor-pointer bg-white br_6"
                >
                  <i class="fas fa-download text_master"></i>
                </div>
              </div>
              {TableData?.length > 0 && (
                <DownloadComponent options={downloadOptions} onDownload={downloadPDF} />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className=" pb-3  custom_pagination customise_table2 expandable-table expandable-table2 shadow_sm_4   ">
        <DataTable
          columns={columns2}
          rowData={TableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onChangeTable={(current, Size) => onChangeTable(current, Size)}
          total={TotalCount}
          scroll={TotalCount > 2 ? { y: 400 } : ""}
          setPageSize={setpageSize}
        />
      </div>
    </>
  );
}

export default LoginReports;
